import { render } from "./panel-left.vue?vue&type=template&id=5dd7451b&scoped=true"
import script from "./panel-left.vue?vue&type=script&lang=js"
export * from "./panel-left.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5dd7451b"

export default script